import {
    createTableColumn,
    DataGrid,
    DataGridBody,
    DataGridCell,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow
} from "@fluentui/react-components";
import {Link} from "react-router-dom";
import {Button, Typography} from "@mui/material";

function CampGrid({items, additionalColumns = [], link = 'id'}) {

    const columns = [
        createTableColumn ({
            columnId: "start_date",
            compare: (a, b) => {
                return a.start_date > b.start_date;
            },
            renderHeaderCell: () => {
                return "Termin";
            },
            renderCell: (item) => (<div>
                <Typography variant={'h6'} fontSize={'small'} fontWeight={'bold'}>{item.start_date}</Typography>
                <Typography variant={'p'} fontSize={'small'}>do {item.end_date}</Typography>
                    </div>)
        }),
        createTableColumn ({
            columnId: "camp",
            compare: (a, b) => {
                return a.camp.localeCompare(b.camp);
            },
            renderHeaderCell: () => {
                return "Wydarzenie";
            },
            renderCell: (item) => <Link to={`/camp/${item[link]}`}><Button sx={{textAlign: 'left'}} type={'text'} color={'info'}>{item.camp}</Button></Link>
        }),
        createTableColumn ({
            columnId: "organization",
            compare: (a, b) => {
                return a.organization.localeCompare(b.organization);
            },
            renderHeaderCell: () => {
                return "Organizator";
            },
            renderCell: (item) => (<div style={{textAlign: 'left'}}>
                <Typography variant={'h6'} fontSize={'small'} fontWeight={'bold'}>{item.organization}</Typography>
                <Typography variant={'h6'} fontSize={'small'} fontWeight={'bold'}>{item.organizer}</Typography>
                <Typography variant={'p'} fontSize={'small'}>{item.season}</Typography>
            </div>)
        }),
            ...additionalColumns,
        createTableColumn ({
            columnId: "more",
            renderHeaderCell: () => {
                return "Zapisy";
            },
            renderCell: (item) => {
                const today = new Date();
                const registration = new Date(item.registration_start);
                const closed = new Date(item.closed ?? item.start_date);
                if (closed < today) {
                    return <Link to={`/camp/${item[link]}`}><Button type={'outlined'} color={'error'}>Zamknięte</Button></Link>
                }
                if (registration < today) {
                    return <Link to={`/camp/${item[link]}`}><Button type={'outlined'} color={'success'}>Aktywne</Button></Link>
                }
                return <Link to={`/camp/${item[link]}`}><Button type={'outlined'} color={'info'}>Od {item.registration_start?.slice(0, -3)}</Button></Link>
            }
        }),
        /*createTableColumn ({
            columnId: "price",
            compare: (a, b) => {
                return parseFloat(a.price) > parseFloat(b.price);
            },
            renderHeaderCell: () => {
                return "Cena";
            },
            renderCell: (item) => item.price + ' zł'
        }),*/
    ];

    return (
        <DataGrid
            items={items}
            columns={columns}
            sortable
            getRowId={(item) => item.id}
            focusMode="composite"
            style={{minWidth: "95vw"}}
        >
            <DataGridHeader>
                <DataGridRow>
                    {({renderHeaderCell}) => (
                        <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                    )}
                </DataGridRow>
            </DataGridHeader>
            <DataGridBody>
                {({item, rowId}) => (
                    <DataGridRow key={rowId}>
                        {({renderCell}) => (
                            <DataGridCell>{renderCell(item)}</DataGridCell>
                        )}
                    </DataGridRow>
                )}
            </DataGridBody>
        </DataGrid>
    );
}

export default CampGrid;